import { computed } from "nanostores";

import type { ListAgentsData, ListAgentsResponse } from "../api/types.gen.ts";

import { getAgent, listAgents } from "../api/index.ts";
import { PaginationParams } from "../types/pagination.ts";
import { createApiStore } from "./api-store.ts";
import { createPaginationStore } from "./pagination.ts";
import { $router } from "./router.ts";

export const $agentsPagination = createPaginationStore();

const $paginationParamsString = computed(
  $agentsPagination.$paginationParams,
  (params) => JSON.stringify(params),
);

export const $agentsList = createApiStore<ListAgentsResponse, ListAgentsData>(
  listAgents,
  {
    mapToOptions: ([paginationParamsString]) => {
      const paginationParams: PaginationParams = paginationParamsString
        ? JSON.parse(paginationParamsString)
        : { currentPage: 1, pageSize: 10 };

      return {
        query: {
          currentPage: paginationParams.currentPage,
          pageSize: paginationParams.pageSize,
        },
      };
    },
    params: [
      $paginationParamsString,
      computed($router, (route) => String(route?.route)),
    ],
    storeKey: "agentsList",
  },
);

export const $agentContent = createApiStore(getAgent, {
  mapToOptions: ([agentId]) => ({
    path: { id: agentId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "sourceId" in router.params ? router.params.sourceId : null;
    }),
  ],
  storeKey: "agentContent",
});
